(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["auzi-investment"] && !Shopify.designMode) return;
  try {
    

function initAuziInvestment(){document.querySelectorAll('.auzi-investment').forEach(root=>{if(root.dataset.initialized)return;root.dataset.initialized='true';const band=root.querySelector('[data-investor-band]');const params=new URLSearchParams(window.location.search);const hasErrors=!!band?.querySelector('[data-investor-error]');const returnedSuccess=params.get('auzi_enquiry')==='received'||params.get('contact_posted')==='true';let submittedFlag=false;try{submittedFlag=sessionStorage.getItem('auziInvestorSubmitted')==='1'}catch(e){}if(hasErrors){try{sessionStorage.removeItem('auziInvestorSubmitted')}catch(e){}}if(band&&(returnedSuccess||(submittedFlag&&!hasErrors))){const formUi=band.querySelector('[data-investor-form-ui]');const success=band.querySelector('[data-investor-success]');if(formUi)formUi.hidden=true;if(success){success.hidden=false;requestAnimationFrame(()=>{const status=success.querySelector('[role="status"]');if(status)status.focus({preventScroll:true});success.scrollIntoView({behavior:'smooth',block:'center'})})}try{sessionStorage.removeItem('auziInvestorSubmitted')}catch(e){}}const investorForm=band?.querySelector('form');if(investorForm){investorForm.addEventListener('submit',()=>{try{sessionStorage.setItem('auziInvestorSubmitted','1')}catch(e){}const button=investorForm.querySelector('button[type="submit"]');if(button){button.disabled=true;button.setAttribute('aria-busy','true')}})}if(!('IntersectionObserver'in window))return;const reveals=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');reveals.unobserve(entry.target)}})},{threshold:.12});root.querySelectorAll('.ai-reveal').forEach(el=>reveals.observe(el));root.querySelectorAll('[data-founder-switch]').forEach(sw=>{const tabs=Array.from(sw.querySelectorAll('[data-founder-target]'));const slides=Array.from(sw.querySelectorAll('[data-founder-slide]'));const activate=key=>{tabs.forEach(tab=>tab.setAttribute('aria-selected',tab.dataset.founderTarget===key?'true':'false'));slides.forEach(slide=>{const active=slide.dataset.founderSlide===key;slide.hidden=!active;slide.classList.toggle('is-active',active)})};tabs.forEach(tab=>tab.addEventListener('click',()=>activate(tab.dataset.founderTarget)));});const links=Array.from(root.querySelectorAll('.ai-chapters a'));const chapters=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){links.forEach(link=>{if(link.getAttribute('href')==='#'+entry.target.id)link.setAttribute('aria-current','location');else link.removeAttribute('aria-current')})}})},{rootMargin:'-10% 0px -60% 0px',threshold:0});links.forEach(link=>{const el=document.getElementById(link.hash.slice(1));if(el)chapters.observe(el)});const cleanup=event=>{if(event.target.contains(root)){reveals.disconnect();chapters.disconnect();document.removeEventListener('shopify:section:unload',cleanup)}};document.addEventListener('shopify:section:unload',cleanup)})}

initAuziInvestment();document.addEventListener('shopify:section:load',initAuziInvestment);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    

  document.documentElement.classList.add('auzi-cart-page');

  (() => {
    const hideCartObstructions = () => {
      const selectors = [
        '#ShopifyChat',
        '[id*="ShopifyChat"]',
        'shopify-chat',
        'iframe[title*="chat" i]',
        'iframe[src*="inbox" i]',
        'iframe[src*="chat" i]'
      ];

      selectors.forEach(selector => {
        document.querySelectorAll(selector).forEach(node => {
          node.style.setProperty('display', 'none', 'important');
          node.style.setProperty('visibility', 'hidden', 'important');
          node.style.setProperty('pointer-events', 'none', 'important');
        });
      });
    };

    hideCartObstructions();

    const observer = new MutationObserver(hideCartObstructions);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    window.addEventListener('pagehide', () => {
      observer.disconnect();
    }, { once: true });
  })();


  (() => {
    function initialiseFooterUI(root) {
      if (!root || root.dataset.footerUiReady) {
        return;
      }
      root.dataset.footerUiReady = 'true';
      const updateError = (() => { try { return JSON.parse(root.querySelector('[data-cart-config]')?.textContent || '{}').updateError || ''; } catch { return ''; } })();

      const utilityDetails = Array.from(root.querySelectorAll('.ac-utility-pill'));

      utilityDetails.forEach(detail => {
        detail.addEventListener('toggle', () => {
          if (!detail.open) return;
          utilityDetails.forEach(other => {
            if (other !== detail) {
              other.open = false;
            }
          });
        });
      });

      const mainCheckout = root.querySelector('.ac-checkout-zone > .ac-checkout');
      const mobileCheckout = root.querySelector('.ac-mobile-checkout');

      function syncMobileCheckout() {
        if (!mainCheckout || !mobileCheckout || window.innerWidth > 749) {
          mobileCheckout?.classList.remove('ac-mobile-checkout--merged');
          return;
        }

        const rect = mainCheckout.getBoundingClientRect();

        // Sticky CTA shows only while the real checkout is still below the viewport.
        // Once the real CTA reaches the viewport (or has been passed), it merges away.
        const shouldMerge = rect.top <= window.innerHeight - 18;

        mobileCheckout.classList.toggle(
          'ac-mobile-checkout--merged',
          shouldMerge
        );
      }

      syncMobileCheckout();

      window.addEventListener('scroll', syncMobileCheckout, { passive: true });
      window.addEventListener('resize', syncMobileCheckout, { passive: true });

      const removeDiscount = root.querySelector('[data-discount-remove]');

      removeDiscount?.addEventListener('click', async () => {
        if (removeDiscount.disabled) return;

        const status = root.querySelector('[data-cart-save-status]');
        removeDiscount.disabled = true;

        try {
          const actions = window.Shopify?.actions;
          if (!actions?.updateCart) {
            throw new Error(updateError);
          }

          const result = await actions.updateCart({ discountCodes: [] });

          if (result.userErrors?.length) {
            throw new Error(updateError);
          }

          window.location.reload();

        } catch (error) {
          removeDiscount.disabled = false;
          if (status) {
            status.textContent = error.message || updateError;
          }
        }
      });
    }

    initialiseFooterUI(document.getElementById('cart-root'));

    document.addEventListener('auzi:cart-rendered', event => {
      initialiseFooterUI(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
